import { Component, inject, signal } from '@angular/core';
import { FormsModule, NgForm } from '@angular/forms';
import { LoadingIndicator } from '../../shared/loading-indicator/loading-indicator';
import { Session } from '../../services/session';
import { SchoolService } from '../../services/school';
import { ApiEndpoints } from '../../core/api-endpoints';
import { Router } from '@angular/router';
import { FlashService } from '../../services/flash';

@Component({
  selector: 'app-admin-create-school',
  imports: [FormsModule, LoadingIndicator],
  templateUrl: './admin-create-school.html',
  styleUrl: './admin-create-school.css',
})
export class AdminCreateSchool {
  constructor(
    private session: Session,
    private schoolService: SchoolService,
    private router: Router,
  ) {
    const token = this.session.getItem('token');

    if (this.session.decodeToken(token)?.role !== 'SUPER_ADMIN' || !token) {
      this.router.navigate(['/']);
      return;
    }
  }

  protected isLoading = signal<boolean>(false);
  protected location!: string;
  protected schoolName!: string;
  protected readonly flashService = inject(FlashService);

  protected createSchool(form: NgForm): void {
    this.isLoading.set(true);

    if (form.invalid) {
      this.flashService.failure('Fill all required fields.');
      return;
    }

    const schoolForm = {
      school_name: this.schoolName,
      location: this.location,
    };

    this.schoolService.createSchool(`${ApiEndpoints.url}/school`, schoolForm).subscribe({
      next: () => {
        this.isLoading.set(false);
        this.flashService.success('School created successfully.');

        setTimeout(() => {
          this.router.navigate(['/signup']);
        }, 1500);
      },
      error: (err) => {
        this.isLoading.set(false);
        this.flashService.failure(err?.error?.message ?? 'Failed to create School');
      },
    });
  }
}
